import type Highcharts from "highcharts";

/** Euclidean distance between two points in plot pixel space (marker / vector density culling). */
export function pixelDistanceBetweenPoints(
  chart: Highcharts.Chart,
  a: Highcharts.Point,
  b: Highcharts.Point,
): number | undefined {
  if (a.x == null || b.x == null || a.y == null || b.y == null) return undefined;

  const xAxis = chart.xAxis[0];
  const yAxis = chart.yAxis[0];

  const xa = xAxis.toPixels(a.x);
  const ya = yAxis.toPixels(a.y);
  const xb = xAxis.toPixels(b.x);
  const yb = yAxis.toPixels(b.y);

  return Math.sqrt(Math.pow(xb - xa, 2) + Math.pow(yb - ya, 2));
}
